import { Injectable } from '@angular/core';
// Import the `pdfjs-dist` library
import * as pdfjsLib from 'pdfjs-dist';
// Import the worker script (required for PDF rendering)
import { GlobalWorkerOptions } from 'pdfjs-dist';

@Injectable({
  providedIn: 'root'
})
export class PdfRendererService {

  constructor() {
    // Set the workerSrc property to the path of the worker script
    GlobalWorkerOptions.workerSrc = 'assets/js/pdf-worker/pdf.worker.min.js';
  }

  async loadPdfAsImage(pdfUrl: string, pageNumber: number = 1): Promise<HTMLCanvasElement> {
    const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
    const page = await pdf.getPage(pageNumber);

    const viewport = page.getViewport({ scale: 3.0 });
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Unable to get canvas context');
    }
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport
    };
    await page.render(renderContext).promise;
    return canvas;
  }
}
